import { render, staticRenderFns } from "./pc-leg-tc-vendor-block.vue?vue&type=template&id=fbe851e2&"
import script from "./pc-leg-tc-vendor-block.vue?vue&type=script&lang=js&"
export * from "./pc-leg-tc-vendor-block.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports